import React, { FC } from "react";
import DesktopMenu from "containers/common/sections/layout/NewNav/DesktopMenu";
import MobileMenu from "containers/common/sections/layout/NewNav/MobileMenu";
import Desktop from "evcharging/components/Desktop";
import Mobile from "evcharging/components/Mobile";

export interface NewNavInterface {
  subNav?: Array<{
    href: string;
    label: string;
    sub?: {
      title: string;
      links: Array<{
        href: string;
        label: string;
      }>;
    };
  }>;
}

const NewNav: FC<NewNavInterface> = (props) => {
  const { subNav } = props;

  return (
    <>
      <Desktop>
        <DesktopMenu subNav={subNav} />
      </Desktop>
      <Mobile>
        <MobileMenu subNav={subNav} />
      </Mobile>
    </>
  );
};

export default NewNav;
